var baseColSizeMap = {
  xs: '48px',
  s: '140px',
  m: '210px',
  l: '350px'
};
export var getCellSizes = () => ({
  xs: {
    minWidth: baseColSizeMap.xs,
    maxWidth: baseColSizeMap.xs,
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 0
  },
  s: {
    minWidth: baseColSizeMap.s,
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: 0
  },
  m: {
    minWidth: baseColSizeMap.m,
    flexGrow: 1.5,
    flexShrink: 0,
    flexBasis: 0
  },
  l: {
    minWidth: baseColSizeMap.l,
    flexGrow: 2.5,
    flexShrink: 0,
    flexBasis: 0
  }
});
export var getFixedCellSize = size => typeof size === 'number' ? {
  minWidth: "".concat(size, "px"),
  width: "".concat(size, "px"),
  maxWidth: "".concat(size, "px")
} : {};
//# sourceMappingURL=_table.utils.js.map